import { render, staticRenderFns } from "./PainelCliente.vue?vue&type=template&id=7e355fb4&"
import script from "./PainelCliente.vue?vue&type=script&lang=js&"
export * from "./PainelCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports